/* tslint:disable */
/* eslint-disable */
export enum FileType {
  Pdf = 'PDF',
  Png = 'PNG',
  Jpg = 'JPG',
  Xml = 'XML',
  Dwg = 'DWG',
  Ifc = 'IFC',
  Rvt = 'RVT',
  Nwd = 'NWD',
  Frac = 'FRAC',
  Other = 'OTHER'
}
